import Vue from 'vue'
import axios from "axios"
import api from '../api'
import router from "@/router"
import {getEstimatedDate} from "@/utils";

const comanda = {
  cerinte_client: '<div></div>',
  nota_constatare: '<div></div>',
  defectiuni: '<div></div>',
  asigurator: '<div></div>',
  lucrari: '<div></div>',
  piese_client: '<div></div>',
  observatii: '<div></div>',
  mecanic: '<div></div>',
  termen_estimativ: getEstimatedDate(),
  nota: '<div>Subsemnatul, parcipant la constatarea efectuata de reprezentatul SERVICE, am luat la cunostinta de cele mentionate in prezenta si am primit un exemplar. In cazul in care la efectuarea reparatiilor la vehiculul mentionat mai sus rezulta si alte repere neconstatate in prezenta nota, beneficiarul poate solicita o noua reconstatare. SERVICE-ul nu raspunde pentru obiectele personale lasate in masina. Masinile fabricate pana in 2012 datorita vechimii, au risc ridicat ca la demontare sa apara alte probleme cu prezoanele, suruburile si piulitele ruginite. Nu raspundem si nu ne asumam riscul la aceste probleme.</div>',
  date: new Date()
}

export const state = {
  comenzi: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 10
  },
  comandaTemplate: {
    car: {},
    comanda,
    deviz: [{}, {}, {}],
    client: {}
  },
  comanda: {
    car: {},
    comanda,
    deviz: [{}, {}, {}],
    client: {},
    deviz_date: new Date(),
    booking_date: undefined,
    booking_time: undefined,
    invoiced: false,
    invoice_id: undefined,
    dosar_dauna: false,
  },
  formularComanda: comanda,
  intrariRar: [],
  devizTotalStaticValues: [],
  deviz: {
    parts: [],
    manopera: []
  },
  deviz_oferta: {
    parts: [],
    manopera: []
  },
  is_request: false,
}

export const mutations = {
  SET_COMANDA (state, comanda) {
    state.deviz.parts = [];
    state.deviz.manopera = [];
    comanda.deviz.forEach(obj => {
      if (obj.manopera) {
        obj.total = obj.total || Math.round((+obj.pretUnitate || 0) * (+obj.durata || 0));
        obj.denumire && state.deviz.manopera.push(obj);
      } else {
        obj.denumire && state.deviz.parts.push(obj);
      }
    })

    if (!comanda.comanda.termen_estimativ || comanda.comanda.termen_estimativ === '<div></div>') {
      comanda.comanda.termen_estimativ = getEstimatedDate()
    }

    if (comanda.dosar_dauna === undefined) {
      comanda.dosar_dauna = false
    }

    if (comanda.comanda.asigurator === undefined) {
      comanda.comanda.asigurator = '<div></div>'
    }

    state.comanda = comanda;
  },
  SET_RAR_ENTRIES (state, value) {
    state.intrariRar = value
  },
  SET_CAR_FIELD_VALUE (state, {name, value}) {
    Vue.set(state.comanda.car, name, value)
  },
  SET_CAR_DETAILS (state, details) {
    // we fill only the static values
    const fields = ['numar', 'marca', 'model', 'sasiu', 'carburant', 'cilindree', 'putere', 'culoare', 'an', 'itp'];
    fields.forEach(val => {
      Vue.set(state.comanda.car, val, details[val])
    })
  },
  SET_CLIENT_FIELD_VALUE (state, {name, value}) {
    Vue.set(state.comanda.client, name, value)
  },
  SET_DEVIZ_FIELD_VALUE (state, {tableName, index, value, field}) {
    Vue.set(state.deviz[tableName][index], field, value);
  },
  SET_DEVIZ_FIELD_VALUE_DEVIZ_OFERTA (state, {tableName, index, value, field}) {
    Vue.set(state.deviz_oferta[tableName][index], field || 'denumire', value);
  },
  RESET_FORMULAR_INTRARE_NOUA (state) {
    state.comanda = {
      car: {},
      comanda: {
        cerinte_client: '<div></div>',
        nota_constatare: '<div></div>',
        defectiuni: '<div></div>',
        asigurator: '<div></div>',
        lucrari: '<div></div>',
        piese_client: '<div></div>',
        observatii: '<div></div>',
        mecanic: '<div></div>',
        termen_estimativ: '<div></div>',
        nota: '<div>Subsemnatul, parcipant la constatarea efectuata de reprezentatul SERVICE, am luat la cunostinta de cele mentionate in prezenta si am primit un exemplar. In cazul in care la efectuarea reparatiilor la vehiculul mentionat mai sus rezulta si alte repere neconstatate in prezenta nota, beneficiarul poate solicita o noua reconstatare. SERVICE-ul nu raspunde pentru obiectele personale lasate in masina. Masinile fabricate pana in 2012 datorita vechimii, au risc ridicat ca la demontare sa apara alte probleme cu prezoanele, suruburile si piulitele ruginite. Nu raspundem si nu ne asumam riscul la aceste probleme.</div>',
        date: new Date()
      },
      deviz: [{}, {}, {}],
      client: {},
      dosar_dauna: false
    }
  },
  STRIP_EMPTY_FIELDS_DEVIZ (state) {
    const deviz = state.comanda.deviz.filter(({denumire, durata, pretUnitate}) => denumire && durata && pretUnitate)
    Vue.set(state.comanda, 'deviz', deviz)
  },
  SET_COMENZI (state, payload) {
    const items = Array.isArray(payload) ? payload : (payload && payload.items) || []
    Vue.set(state, 'comenzi', items)
    if (payload && !Array.isArray(payload)) {
      Vue.set(state, 'pagination', {
        total: +payload.total || 0,
        page: +payload.page || 1,
        limit: +payload.limit || 10
      })
    }
  },
  REMOVE_LAST_DEFECT (state) {
    state.comanda.comanda.fields.pop()
  },
  ADD_MANOPERA (state, index) {
    Vue.set(state.comanda.deviz[index], 'manopera', !state.comanda.deviz[index].manopera)
  },
  ADD_DEFECT (state) {
    state.comanda.comanda.fields.push(undefined)
  },
  ADD_PARTS_DEVIZ_FIELD (state) {
    state.deviz.parts.push({denumire: '', total: 0, pretUnitate: 0, durata: 1});
  },
  ADD_PARTS_DEVIZ_FIELD_DEVIZ_OFERTA (state) {
    state.deviz_oferta.parts.push({denumire: '', total: 0, pretUnitate: 0, durata: 1});
  },
  ADD_MANOPERA_DEVIZ_SIMPLU_FIELD (state, { manopera: pretUnitate, tva }) {
    state.deviz.manopera.push({
      denumire: '',
      manopera: true,
      pretUnitate,
      total: +pretUnitate,
      durata: 1
    });
  },
  ADD_MANOPERA_DEVIZ_FIELD (state, { manopera: pretUnitate, tva }) {
    state.deviz.manopera.push({
      denumire: '',
      manopera: true,
      pretUnitate,
      total: (+pretUnitate + (+pretUnitate * +`0.${tva}`)).toFixed(2),
      durata: 1
    });
  },
  ADD_MANOPERA_DEVIZ_FIELD_DEVIZ_OFERTA (state, { manopera: pretUnitate, tva }) {
    state.deviz_oferta.manopera.push({
      denumire: '',
      manopera: true,
      pretUnitate,
      total: (+pretUnitate + (+pretUnitate * +`0.${tva}`)).toFixed(2),
      durata: 1
    });
  },
  UPDATE_COMANDA_HTML_FIELD (state, {key, htmlVal}) {
    Vue.set(state.comanda.comanda, key, htmlVal)
  },
  UPDATE_COMANDA_NOUA_FIELD (state, {key, value}) {
    state.comanda[key] = value;
  },
  SET_DEVIZ_ITEM_DURATA (state, {value, index, tableName}) {
    // modify the total
    const item = state.deviz[tableName][index];
    state.deviz[tableName][index].durata = value;
    state.deviz[tableName][index].total = convertTimeToPrice(+value, +item.pretUnitate);
  },
  SET_DEVIZ_ITEM_DURATA_DEVIZ_OFERTA (state, {value, index, tableName}) {
    // modify the total
    const item = state.deviz_oferta[tableName][index];
    state.deviz_oferta[tableName][index].durata = value;
    state.deviz_oferta[tableName][index].total = convertTimeToPrice(+value, +item.pretUnitate);
  },
  SET_DEVIZ_ITEM_PRET_UNITATE (state, {value, index, tableName, tva}) {
    // modify the total
    state.deviz[tableName][index].pretUnitate = value;
    const durata = state.deviz[tableName][index].durata;

    // Convert time format to decimal hours (2.3 -> 2.5)
    const convertTimeToDecimal = (timeValue) => {
      const timeStr = timeValue.toString();
      const [hours, minutesPart = '0'] = timeStr.split('.');

      // Pad minutes to 2 digits if needed: 3 -> 30, 15 -> 15
      const paddedMinutes = minutesPart.padEnd(2, '0');
      const minutes = Math.min(+paddedMinutes, 59); // Cap at 59 minutes

      return +hours + (minutes / 60);
    };

    const decimalHours = convertTimeToDecimal(durata);
    state.deviz[tableName][index].total = ((+value * decimalHours) + (+value * decimalHours * +tva/100)).toFixed(2);
  },
  SET_DEVIZ_ITEM_PRET_UNITATE_DEVIZ_OFERTA (state, {value, index, tableName, tva}) {
    // modify the total
    state.deviz_oferta[tableName][index].pretUnitate = value;
    const durata = state.deviz_oferta[tableName][index].durata;

    // Convert time format to decimal hours (2.3 -> 2.5)
    const convertTimeToDecimal = (timeValue) => {
      const timeStr = timeValue.toString();
      const [hours, minutesPart = '0'] = timeStr.split('.');

      // Pad minutes to 2 digits if needed: 3 -> 30, 15 -> 15
      const paddedMinutes = minutesPart.padEnd(2, '0');
      const minutes = Math.min(+paddedMinutes, 59); // Cap at 59 minutes

      return +hours + (minutes / 60);
    };

    const decimalHours = convertTimeToDecimal(durata);
    state.deviz_oferta[tableName][index].total = ((+value * decimalHours) + (+value * decimalHours * +tva/100)).toFixed(2);
  },
  SET_DEVIZ_ITEM_PRET_UNITATE_MANOPERA (state, {value, index, tableName}) {
    // modify the total
    const item = state.deviz[tableName][index];
    state.deviz[tableName][index].pretUnitate = value;
    state.deviz[tableName][index].total = convertTimeToPrice(item.durata, value);
  },
  SET_DEVIZ_ITEM_PRET_UNITATE_FARA_TVA (state, {value, index, tableName, tva}) {
    state.deviz[tableName][index].total = +value;
    const quantity = +state.deviz[tableName][index].durata;
    state.deviz[tableName][index].pretUnitate = ((value / +`1.${tva}`) / quantity).toFixed(2);
  },
  SET_DEVIZ_ITEM_PRET_UNITATE_FARA_TVA_DEVIZ_OFERTA (state, {value, index, tableName, tva}) {
    state.deviz_oferta[tableName][index].total = +value;
    const quantity = +state.deviz_oferta[tableName][index].durata;
    state.deviz_oferta[tableName][index].pretUnitate = ((value / +`1.${tva}`) / quantity).toFixed(2);
  },
  SET_DEVIZ_SIMPLU_MANOPERA_ITEM_TOTAL (state, {value, index, tva}) {
    state.deviz.manopera[index].total = +value;
    const pretOra = state.deviz.manopera[index].pretUnitate;
    const hours = Math.floor(+value / +pretOra);
    const minutes = Math.round(((+value / +pretOra) - hours) * 60);
    const durata = minutes === 0
      ? hours
      : `${hours}.${minutes.toString().padStart(2, '0')}`;
    state.deviz.manopera[index].durata = durata;
  },
  SET_DEVIZ_MANOPERA_ITEM_TOTAL (state, {value, index, tva}) {
    state.deviz.manopera[index].total = +value;
    const pretUnitate = state.deviz.manopera[index].pretUnitate;
    const durata = (+value / +`1.${tva}`) / +pretUnitate;
    state.deviz.manopera[index].durata = durata.toString().length > 1 ? durata.toFixed(2) : durata;
  },
  SET_DEVIZ_MANOPERA_ITEM_TOTAL_DEVIZ_OFERTA (state, {value, index, tva}) {
    state.deviz_oferta.manopera[index].total = +value;
    const pretUnitate = state.deviz_oferta.manopera[index].pretUnitate;
    const durata = (+value / +`1.${tva}`) / +pretUnitate;
    state.deviz_oferta.manopera[index].durata = durata.toString().length > 1
      ? durata.toFixed(2)
      : durata;
  },
  SET_DEVIZ_ITEM_VALOARE_TOTALA (state, {index, tableName, tva}) {
    const PU = +state.deviz[tableName][index].pretUnitate;
    const quantity = +state.deviz[tableName][index].durata;
    state.deviz[tableName][index].total = ((+PU * quantity) + (+PU * quantity * +tva/100)).toFixed(2);
  },
  SET_DEVIZ_ITEM_VALOARE_TOTALA_DEVIZ_OFERTA (state, {index, tableName, tva}) {
    const PU = +state.deviz_oferta[tableName][index].pretUnitate;
    const quantity = +state.deviz_oferta[tableName][index].durata;
    state.deviz_oferta[tableName][index].total = ((+PU * quantity) + (+PU * quantity * +tva/100)).toFixed(2);
  },
  HANDLE_DURATA_PIESE (state, {value, index}) {
    const { pretUnitate } = state.deviz.parts[index];
    state.deviz.parts[index].durata = value;
    state.deviz.parts[index].total = (+pretUnitate * +value).toFixed(2);
  },
  HANDLE_DURATA_PIESE_DEVIZ_OFERTA (state, {value, index}) {
    const { pretUnitate } = state.deviz_oferta.parts[index];
    state.deviz_oferta.parts[index].durata = value;
    state.deviz_oferta.parts[index].total = (+pretUnitate * +value).toFixed(2);
  },
  HANDLE_DELETE_ROW (state, {tableName, index}) {
    state.deviz[tableName].splice(index, 1);
  },
  HANDLE_DELETE_ROW_DEVIZ_OFERTA (state, {tableName, index}) {
    state.deviz_oferta[tableName].splice(index, 1);
  },
  RESET_DEVIZ_DATA (state) {
    state.deviz = {
      parts: [],
      manopera: []
    }
  },
  RESET_DEVIZ_DATA_DEVIZ_OFERTA (state) {
    state.deviz_oferta = {
      parts: [],
      manopera: []
    }
  },
  HANDLE_DURATA_MANOPERA (state, {value, index, tva}) {
    const { pretUnitate } = state.deviz.manopera[index];
    const total = (+value * +pretUnitate) + (+value * +pretUnitate * +`0.${tva}`);
    Vue.set(state.deviz.manopera[index], 'durata', value);
    Vue.set(state.deviz.manopera[index], 'total', total.toFixed(2));
  },
  HANDLE_DURATA_MANOPERA_DEVIZ_OFERTA (state, {value, index, tva}) {
    const { pretUnitate } = state.deviz_oferta.manopera[index];
    const total = (+value * +pretUnitate) + (+value * +pretUnitate * +`0.${tva}`);
    Vue.set(state.deviz_oferta.manopera[index], 'durata', value);
    Vue.set(state.deviz_oferta.manopera[index], 'total', total.toFixed(2));
  },
  SET_DEVIZ_OFERTA (state, comanda) {
    state.deviz_oferta.parts = [];
    state.deviz_oferta.manopera = [];
    comanda.deviz_oferta.forEach(obj => {
      if (obj.manopera) {
        obj.total = obj.total || Math.round((+obj.pretUnitate || 0) * (+obj.durata || 0));
        obj.denumire && state.deviz_oferta.manopera.push(obj);
      } else {
        obj.denumire && state.deviz_oferta.parts.push(obj);
      }
    })
    state.comanda = comanda;
  },
  MARK_DEVIZ_INVOICED (state, filename) {
    state.comanda.invoiced = true;
    state.comanda.invoice_id = filename.replace('.pdf', '');
  },

  SET_IS_REQUEST (state,payload) {
    state.is_request = payload
  },
}

export const actions = {
  async scan_talon ({ commit }, file) {
    const formData = new FormData()
    formData.append('talon', file)
    const { data } = await axios.post(api.scan_talon, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    if (data && data.car) {
      commit('SET_CAR_DETAILS', data.car)
    }
    if (data && data.client) {
      if (data.client.proprietar !== undefined) {
        commit('SET_CLIENT_FIELD_VALUE', { name: 'proprietar', value: data.client.proprietar })
      }
      if (data.client.nume !== undefined) {
        commit('SET_CLIENT_FIELD_VALUE', { name: 'nume', value: data.client.nume })
      }
    }
    return data
  },
  async get_comenzi ({state, commit}) {
    try {
      const params = router.currentRoute.query
      const { data } = await axios(api.comenzi, {
        params
      });
      commit('SET_COMENZI', data);
    } catch (e) {
      state.error = 'Eroare primire comenzi din server.'
    }
  },
  async save_comanda ({state, commit}, options = {}) {
    try {
      const { data } = await axios.post(api.comanda_noua, state.comanda);
      const route = options.route_to ? `${options.route_to}/${data._id}` : 'comenzi';
      await router.push(`/${route}`);
    } catch (e) {
      if (e?.response?.status === 403) {
        commit('SET_TRIAL_EXPIRED_MODAL', true, { root: true })
        return
      }
      state.error = 'Eroare salvare comanda.'
    }
  },
  async get_comanda ({ state, commit }, id) {
    try {
      const { data } = await axios(`${api.comenzi}/get-comanda/${id}`);
      // because deviz_date was added later, all data until this date
      // do now have this value so we eq to comanda date
      if (!data.deviz_date) {
        data.deviz_date = data.comanda.date;
      }
      const route_name = router.currentRoute.name;
      route_name === 'Deviz-Oferta'
        ? commit('SET_DEVIZ_OFERTA', data)
        : commit('SET_COMANDA', data)
    }
    catch (e) {
      state.error = 'Eroare primire comenzi din server.'
    }
  },
  async update_comanda ({ state }, id) {
    try {
      const url = `${api.update_comanda}/${id}`
      await axios.put(url, state.comanda)
      await router.push('/comenzi')
    } catch (e) {
      state.error = 'Eroare salvare comanda.'
    }
  },
  async save_formular_comanda ({state}, action) {
    try {
      const url = `${api.save_formular_comanda}/${state.comanda._id}`
      await axios.post(url, state.comanda)
      switch (action) {
        case 'print':
          window.print()
          break
        case 'save':
        case 'pdf':
          break
        default:
          window.history.back()
      }
    } catch (e) {
      state.error = 'Eroare salvare comanda.'
    }
  },
  async save_deviz ({state, commit}, action) {
    commit('STRIP_EMPTY_FIELDS_DEVIZ');
    try {
      const url = `${api.save_deviz}/${state.comanda._id}`;
      const payload = {
        deviz_date: state.comanda.deviz_date,
        items: [...state.deviz.parts, ...state.deviz.manopera],
      };
      await axios.post(url, payload);
      switch (action) {
        case 'print':
          window.print();
          break;
        case 'back':
          window.history.back();
          break;
        case 'comenzi':
          await router.push('/comenzi');
          break;
        default:
          break;
      }
    } catch (e) {
      state.error = 'Eroare salvare comanda.'
    }
  },
  async save_deviz_oferta ({state, commit}, { action } = {}) {
    commit('STRIP_EMPTY_FIELDS_DEVIZ');
    try {
      const _id = state.comanda._id || router.currentRoute.params.id;
      const url = `${api.save_deviz}/${_id}`;
      const payload = {
        deviz_oferta: true,
        items: [...state.deviz_oferta.parts, ...state.deviz_oferta.manopera],
      };
      await axios.post(url, payload);
      switch (action) {
        case 'print':
          window.print();
          break;
        case 'back':
          window.history.back();
          break;
        default:
          break;
      }
      return true;
    } catch (e) {
      state.error = 'Eroare salvare comanda.'
    }
  },
  async make_pdf ({state, commit}, payload = {}) {
    try {
      commit('SET_IS_REQUEST', true)
      const url = `/api/download-pdf/${payload.id}${payload.oferta ? '?oferta=true' : ''}`;
      commit('SET_REQ_IN_PROGRESS_NAME', 'download_pdf');
      const { data } = await axios.get(url, { responseType: 'arraybuffer' });
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      commit('SET_IS_REQUEST', false)

      const pdfBlob = new Blob([data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // If payload.pdf is true → download instead of open
      if (payload.pdf === true) {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');

        const fileName = `Deviz_${yyyy}-${mm}-${dd}.pdf`;

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(pdfUrl);
        payload.clbk && payload.clbk();
        return; // stop here
      }

      // (optional) if you still want to handle other cases when pdf is false:
      const newWindow = window.open();
      if (newWindow) {
        newWindow.location.href = pdfUrl;
        newWindow.onload = () => {
          setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
        };
      }
      else {
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'document.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(pdfUrl);
      }
    }
    catch (err) {
      console.log(err);
      state.error = 'Eroare salvare comanda.'
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      commit('SET_IS_REQUEST', false)
    }
  },
  async get_intrari_by_date_range ({commit}, range) {
    try {
      const {data} = await axios.post(api.intrari_by_date_range, range)
      commit('SET_RAR_ENTRIES', data)
    } catch (e) {
      console.log(e.response)
    }
  },
  async delete_comanda ({ state }, id) {
    try {
      const url = `${api.comenzi}/delete-comanda/${id}`;
      await axios.delete(url);
      await router.push('/comenzi');
    } catch (err) {
      console.log(err);
      state.error = 'Eroare stergere comanda.';
    }
  },
  async emit_deviz_invoice ({ commit, rootState }) {
    try {
      const comanda_id = router.currentRoute.params.id;
      commit('SET_REQ_IN_PROGRESS_NAME', 'generate_invoice');
      const invoice_data = Format_Invoice_Data(rootState);
      const { data, headers } = await axios.post(`${api.invoice}/${comanda_id}`, invoice_data, {
        responseType: 'blob',               // <— important
        headers: { Accept: 'application/pdf' }
      });
      commit('SET_REQ_IN_PROGRESS_NAME', '');

      // Try to get filename from Content-Disposition
      let filename = 'invoice.pdf';
      const cd = headers['content-disposition'];
      if (cd) {
        const match =
          /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(cd);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }
      // set deviz invoices
      commit('MARK_DEVIZ_INVOICED', filename);

      // Create a download
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
    catch (err) {
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      const message = await Extract_Axios_Error(err);
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      console.error('❌ Invoice Error:', message);
      this._vm.$toast.error(message || 'Oops!')
    }
  },
  async clone_deviz_oferta_in_deviz ({ commit }, { id } ) {
    try {
      await axios.post(`${api.deviz}/clone-oferta-to-deviz`, { id_intrare: id });
      // show toast with success message
      this._vm.$toast.success('Deviz ofertă copiat în deviz!');
      // redirect to ?
      // await router.push('/comenzi');
    }
    catch (err) {
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      const message = await Extract_Axios_Error(err);
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      console.error('❌ Invoice Error:', message);
      this._vm.$toast.error(message || 'Oops!')
    }
  },
  async download_receptie_pdf ({ commit }, id) {
    commit('SET_IS_REQUEST', true)
    try {
      const { data } = await axios.get(
        `${api.comenzi}/${id}/receptie-pdf`,
        {
          responseType: 'blob'
        }
      )
      window.open( URL.createObjectURL(data), '_blank')
    } catch (err) {
      console.error(err)
      this._vm.$toast?.error(
        'Eroare descarcare fisa receptie.'
      )
    } finally {
      commit('SET_IS_REQUEST', false)
    }
  },
  async get_formular (_, { id, endpoint }) {
    try {
      const { data } = await axios.get(`${api.comenzi}/${id}/${endpoint}`)
      return data
    } catch (err) {
      console.log(err)
      this._vm.$toast && this._vm.$toast.error('Eroare incarcare formular.')
    }
  },
  async save_formular (_, { id, endpoint, payload }) {
    try {
      const { data } = await axios.put(`${api.comenzi}/${id}/${endpoint}`, payload)
      return data
    } catch (err) {
      console.log(err)
      this._vm.$toast && this._vm.$toast.error('Eroare salvare formular.')
    }
  },
  async download_formular_pdf ({ commit }, { id, endpoint }) {
    commit('SET_IS_REQUEST', true)

    try {
      const { data } = await axios.get(
        `${api.comenzi}/${id}/${endpoint}-pdf`,
        { responseType: 'blob' }
      )

      window.open(URL.createObjectURL(data), '_blank')

    } catch (err) {
      console.error(err)
      this._vm.$toast?.error(
        'Eroare descarcare formular PDF.'
      )
    } finally {
      commit('SET_IS_REQUEST', false)
    }
  },
  async download_comanda_pdf ({ commit, state }) {
    try {
      commit('SET_IS_REQUEST', true)
      const response = await axios.get(`${api.comenzi}/${state.comanda._id}/pdf`, {
        responseType: 'blob',
      })
      return response.data

    } catch (err) {
      console.error(err)
      throw err

    } finally {
      commit('SET_IS_REQUEST', false)
    }
  }
}

export const getters = {
  get_deviz_oferta: state => {
    return state.deviz_oferta || {};
  },
  get_deviz_parts: state => {
    return state.deviz?.parts || [];
  },
  get_deviz_manopera: state => {
    return state.deviz?.manopera || [];
  },
  total_deviz_parts: (state, _, rootState) => {
    const tva = rootState.setari?.settings?.tarife?.tva;
    return state.deviz.parts
      .reduce((acc, item) => {
        return acc + (+item.total || 0) / +`1.${tva}`;
      }, 0);
  },
  total_deviz_manopera: (state, _, rootState) => {
    const tva = rootState.setari?.settings?.tarife?.tva;
    return state.deviz.manopera
      .reduce((acc, item) => {
        return acc + (+item.total || 0) / +`1.${tva}`;
      }, 0);
  },
  total_deviz_tva: (state, _, rootState) => {
    const TVA = rootState.setari?.settings?.tarife?.tva;
    const TOTAL_TVA_PIESE = state.deviz.parts
      .reduce((acc, { total }) => {
        return acc + +total;
      }, 0);
    const TOTAL_TVA_MANOPERA = state.deviz.manopera
      .reduce((acc, { total }) => {
        return acc + +total;
      }, 0);
    return ((+TOTAL_TVA_PIESE + +TOTAL_TVA_MANOPERA) - ((+TOTAL_TVA_PIESE + +TOTAL_TVA_MANOPERA) / `1.${TVA}`)).toFixed(2);
  },
  total_deviz_oferta_parts: (state, _, rootState) => {
    const tva = rootState.setari?.settings?.tarife?.tva;
    return state.deviz_oferta.parts
      .reduce((acc, item) => {
        return acc + (+item.total || 0) / +`1.${tva}`;
      }, 0);
  },
  total_deviz_oferta_manopera: (state, _, rootState) => {
    const tva = rootState.setari?.settings?.tarife?.tva;
    return state.deviz_oferta.manopera
      .reduce((acc, item) => {
        return acc + (+item.total || 0) / +`1.${tva}`;
      }, 0);
  },
  total_deviz_oferta_tva: (state, _, rootState) => {
    const TVA = rootState.setari?.settings?.tarife?.tva;
    const TOTAL_TVA_PIESE = state.deviz_oferta.parts
      .reduce((acc, { total }) => {
        return acc + +total;
      }, 0);
    const TOTAL_TVA_MANOPERA = state.deviz_oferta.manopera
      .reduce((acc, { total }) => {
        return acc + +total;
      }, 0);
    return ((+TOTAL_TVA_PIESE + +TOTAL_TVA_MANOPERA) - ((+TOTAL_TVA_PIESE + +TOTAL_TVA_MANOPERA) / `1.${TVA}`)).toFixed(2);
  },
}

function convertTimeToPrice (time, pricePerUnit) {
  const timeStr = String(time || '0');
  const [hours = '0', minutesStr = '0'] = timeStr.split('.');
  const minutes = minutesStr ? parseInt(minutesStr.padEnd(2, '0')) : 0;
  const totalHours = +hours + minutes / 60;
  return Math.round(totalHours * pricePerUnit).toFixed(2);
}

function Format_Invoice_Data (rootState) {
  const { client } = rootState.comenzi?.comanda;
  const service = rootState.setari?.settings?.dateService;
  const settings = rootState.setari?.settings;
  const products = rootState.comenzi?.deviz?.manopera
    .map(o => ({
      name: o.denumire,
      price: +o.pretUnitate,
      measuringUnit: 'ore',
      currency: 'RON',
      vatName: 'Normala',
      vatPercentage: 0,
      vatIncluded: 1,
      quantity: o.durata,
      productType: 'Serviciu',
    }));

  return {
    cif: service.cui,
    client: {
      cif: client.cui,
      name: client.numeFirma,
      state: client.state,
      city: client.city,
      vatPayer: true
    },
    issueDate: new Date().toISOString().slice(0,10),
    seriesName: settings.serieFactura,
    language: 'RO',
    precision: 2,
    currency: 'RON',
    products,
    workStation: 'Sediu',
    useStock: 0
  };
}

async function Extract_Axios_Error (err) {
  if (err?.response) {
    const data = err.response.data;

    // If the server sent JSON but we requested 'blob', parse it
    if (data instanceof Blob) {
      const text = await data.text();
      try {
        const json = JSON.parse(text);
        return json.message || text;
      } catch {
        return text;
      }
    }

    if (typeof data === 'string') {
      try {
        const json = JSON.parse(data);
        return json.message || data;
      } catch {
        return data;
      }
    }

    if (data?.message) return data.message;
    return `HTTP ${err.response.status}`;
  }
  return err?.message || String(err);
}